import { useState, useEffect } from 'react';
import api from '../../api';

const useHttpGetPredefinedSchedules = () => {
    const [data, setData] = useState([]);
    const [isReady, setIsReady] = useState(false);

    const fetchSchedules = async () => {
        try {
            const { data: schedules } = await api.get_predefined_schedules();
            setData(schedules);
        } catch (error) {
            console.error('Unexpected error occurred while fetching predefined schedules: ', error);
        } finally {
            setIsReady(true);
        }
    };

    useEffect(() => {
        fetchSchedules();
    }, []);

    return { data, isReady, refetch: fetchSchedules };
};

export default useHttpGetPredefinedSchedules;
